import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    IOS_APP_URL,
    ANDROID_APP_URL,
    isAppLinkConfigured,
} from '../../constants/appLinks';
import '../../styles/landing/AppStoreButtons.css';

type AppStoreButtonsProps = {
    variant?: 'default' | 'compact' | 'light';
    className?: string;
};

function getStoreLinkProps(url: string): Pick<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    'href' | 'onClick' | 'target' | 'rel' | 'aria-disabled'
> {
    const configured = isAppLinkConfigured(url);

    if (!configured) {
        return {
            href: url,
            onClick: (e) => e.preventDefault(),
            'aria-disabled': true,
        };
    }

    return {
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer',
    };
}

const AppStoreButtons: React.FC<AppStoreButtonsProps> = ({
    variant = 'default',
    className = '',
}) => {
    const { t } = useTranslation();

    return (
        <div className={`app-store-buttons app-store-buttons--${variant} ${className}`.trim()}>
            <a
                {...getStoreLinkProps(IOS_APP_URL)}
                className="app-store-btn app-store-btn--ios"
                aria-label={t('cta.downloadIos')}
            >
                <span className="app-store-btn__icon" aria-hidden="true">
                    &#63743;
                </span>
                <span className="app-store-btn__text">{t('cta.downloadIos')}</span>
            </a>
            <a
                {...getStoreLinkProps(ANDROID_APP_URL)}
                className="app-store-btn app-store-btn--android"
                aria-label={t('cta.downloadAndroid')}
            >
                <span className="app-store-btn__icon" aria-hidden="true">
                    &#9654;
                </span>
                <span className="app-store-btn__text">{t('cta.downloadAndroid')}</span>
            </a>
        </div>
    );
};

export default AppStoreButtons;
